jQuery( document ).ready(function() {
  jQuery('.wp-block-create-block-accordion-heading h4').append('<span class="accordion-icon"><i class="fas fa-chevron-down icon-collapsed"></i><i class="fas fa-chevron-up icon-expanded"></i></span>');
});